module.exports = __webpack_public_path__ + "static/media/2022_2A3A9672.e56c6dd0.jpg";